export default __webpack_public_path__ + "static/media/SignOut.5986323e.svg";